/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import { Image,
FlatList,
Text,
View,
ScrollView,
SafeAreaView,
Share,
Platform,
Pressable,
useWindowDimensions} from 'react-native';
import { Loader, Locked } from '../../components';
import styles from './styles';
import {Firestore, Analytics, Crashlytics } from '../../firebase/config';
import { Icon } from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';
import * as Linking from 'expo-linking';
import {BASE_URL_REDIRECT} from "@env";
import * as Haptics from 'expo-haptics';

export default function SingleCatalog(props) {
    const [loading, setLoading] = useState(true);
    const [update, setUpdate] = useState({});
    const [receipt, setReceipt] = useState({});
    const [locked, setLocked] = useState(false);
    const [starIcon, setStarIcon] = useState({icon: 'star-outline', color: 'black'});
    const updateID = props.route.params.update;
    const userID = props.extraData.user.id;
    const userRef = Firestore.collection('users').doc(userID);
    const updatesRef = Firestore.collection('Updates');
    const { navigation } = props;
    const canGoBack = navigation.canGoBack();
    const { width } = useWindowDimensions();
    const descriptionWidth = width - 20;


//Check for read receipt and favorite
useEffect(() => {
const task = userRef.collection('Viewed').doc(updateID).get()
.then((doc) => {
if (doc.exists) {
const receipt = {
id: doc.id,
favorite: doc.data().favorite
}
setReceipt(receipt);
}
else {
setReceipt({id: null, favorite: null});
}
}).catch((err) => {
console.error("Error getting read receipt: ", err);
Crashlytics.recordError(err);
});
return () => task;
},[])



//Fetch Update
useEffect(() => {
updatesRef
.doc(updateID)
.get()
.then((doc) => {
const updateData = doc.data()
updateData.id = doc.id
updateData.favorite = receipt.favorite
if (receipt.favorite) {
setStarIcon({icon: 'star', color: 'red'});
}
setUpdate(updateData);
}).catch((err) => {
if (err.code === "permission-denied") {
setLocked(true);
//analytics log event for locked content...
}
else {
Crashlytics.recordError(error);
}
});
},[receipt]);

//Sets Navigation Options
useEffect(() => {
if (update) {
if (!(canGoBack)) {
navigation.setOptions({
title: update.title,
headerLeft: () => (
<Pressable
style={{ position: 'absolute', left: 15 }}
onPress={() => {
navigation.navigate('Catalogs');
}}>
<Icon
name='home'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
headerRight: () => (
Platform.OS != 'web' &&
<Pressable
style={{ position: 'absolute', right: 15 }}
onPress={() => {
generateShareLink();
}}>
<Icon
name='ios-share'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
});
}
else {
navigation.setOptions({
title: update.title,
headerRight: () => (
Platform.OS != 'web' &&
<Pressable
style={{ position: 'absolute', right: 15 }}
onPress={() => {
generateShareLink();
}}>
{Platform.OS === 'ios'? (
<Icon
name='ios-share'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
) : (
<Icon
name='share'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
)}
</Pressable>
),
});
}
startAnalytics("initial");
if (receipt.id === null) {
generateReadTicket();
}
setLoading(false);
}
else if (locked) {
navigation.setOptions({
title: "Locked",
headerLeft: () => (
<Pressable
style={{ position: 'absolute', left: 15 }}
onPress={() => {
navigation.navigate('Catalogs');
}}>
<Icon
name='home'
type='MaterialCommunityIcons'
color='lightgray'
size={30}
/>
</Pressable>
),
});
startAnalytics("locked");
setLoading(false);
}
},[update, locked]);


//Generate Read Receipt
const generateReadTicket = () => {
console.log("Generating Read Ticket...");
const now = new Date();
userRef
.collection('Viewed')
.doc(update.id)
.set({
updateID: update.id,
userID: userID,
productLine: update.productLine,
catalogID: update.catalog,
date: now,
timestamp: now.getTime()
})
.catch((err) => {
console.error("Error creating read ticket", err);
Crashlytics.recordError(err);
setLoading(false);})
}


const toggleFavorite = () => {
switch (starIcon.icon) {
case 'star':
const removeTask = userRef.collection('Viewed').doc(update.id).update({
favorite: false
}).then(() => {
setStarIcon({icon: 'star-outline', color: 'black'});
if (Platform.OS != 'web') {
Haptics.selectionAsync();
}
}).catch((err) => {console.error("Error removing favorite", err);
Crashlytics.recordError(err);
});
return () => removeTask();
case 'star-outline':
const addTask = userRef.collection('Viewed').doc(update.id).update({
favorite: true
}).then(() => {
setStarIcon({icon: 'star', color: 'red'});
if (Platform.OS != 'web') {
Haptics.selectionAsync();
}
}).catch((err) => {
console.error("Error adding favorite", err);
Crashlytics.recordError(err);
});
return () => addTask();
}
}




const generateShareLink = () => {
const title = "Click the link to view the " + update.title + " update within Empire Distributing!";
const shareParams = {
page: "Catalog Updates",
update: update.id
};
return onShare(title, getLink(shareParams));
};

const renderAttachments = ({item, index}) => {
        return (
      <View style={styles.textIcon}>
              <Icon reverse name="file-present" size={30} color={"black"} reverseColor={"white"} onPress={() => {
              openUrl("Update Attachment", item.url, item.title);
              }} />
              <Text style={styles.iconText}>{item.title}</Text>
              </View>
        )
    }

//Generates Dynamic Link within app.
const getLink = (params) => {
 params = encodeData(params);
return BASE_URL_REDIRECT + params;
}

function encodeData(data) {
    return Object.keys(data).map(function(key) {
        return [key, data[key]].map(encodeURIComponent).join("=");
    }).join("&");
}

      const onShare = async (message, url) => {
      startAnalytics("share");
      let result;
          try {
          if (Platform.OS === "android") {
             result = await Share.share({
              message: url,
            });
          }
          else {
             result = await Share.share({
              message: message,
              url: url
            });
          }
            if (result.action === Share.sharedAction) {
              if (result.activityType) {
                // shared with activity type of result.activityType
              } else {
                // shared
              }
            } else if (result.action === Share.dismissedAction) {
              // dismissed
            }
          } catch (error) {
          console.error("Error sharing catalog update", error);
          alert(error.message);
          Crashlytics.recordError(error);
          }
        };


    //const openUrl = (url, type, title) => {
    const openUrl = (type, url, title) => {
        let redirect;
    switch (type) {
    case "Catalog Update":
    if (update.directUserPageNo) {
     redirect = update.directUserPageNo
    }
    else {
     redirect = 1;
    }
    return navigation.navigate('ViewCatalog', {catalogID: update.catalog, pg: redirect })
    case "Update Attachment":
    if (Platform.OS === 'android') {
    return Linking.openURL(url);
    }
    else {
    return navigation.navigate('View', {data: url, title: title});
    }
    }
    }



    function startAnalytics(method) {
    switch (method) {
    case "initial":
    return Analytics.logEvent('UpdateViewed', {
    screen: 'Catalog Update',
    purpose: 'View Catalog Update',
    updateID: update.id,
    title: update.title,
    });
    case "share":
    return Analytics.logEvent('share', {
    screen: 'CatalogUpdate',
    type: 'Update',
    purpose: 'Share Catalog Update',
    updateID: update.id,
    title: update.title,
    });
    case "locked":
    return Analytics.logEvent('locked', {
    screen: 'CatalogUpdate',
    type: 'Update',
    purpose: 'View Catalog Update',
    updateID: updateID
    });
    default: return;
    }
    }



   if (loading) {
     return (
   <Loader />
     )
   }

   if (locked) {
   return (
   <Locked
    onPress={() => {navigation.navigate('Catalogs')}}
    />
   )
   }


        return (
        <View style={styles.container}>
        <LinearGradient
         colors={['black', '#590000']}
         locations={[.1,1]}
         style={{flex: 1}}
         >
        <SafeAreaView style={styles.container}>
        {update && (
        <View style={styles.updateContainer}>
        <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
         <Icon
          name={starIcon.icon}
          color={starIcon.color}
          onPress={() => {toggleFavorite();}}
          size={30}
          containerStyle={{margin: 10}}
         />
         </View>
        <ScrollView
         showsVerticalScrollIndicator={false}
         showsHorizontalScrollIndicator={false}
         horizontal={false}
         style={{width: "100%"}}
         contentContainerStyle={{alignItems: 'center'}}
        >
        {update.iconURL ? (
        <>
        {update.directUser ? (
        <Pressable
                style={[styles.shadow,{marginTop:20}]}
                onPress={() => {
                openUrl("Catalog Update")
        }}
        >
        <View style={styles.iconLink}>
         <Image
                style={styles.thumbnailImage}
                source={{
                uri: update.iconURL,
                }}
                />
                <Icon name="link" size={30} color={"gray"}></Icon>
                </View>
                </Pressable>
        ) : (
        <Pressable
        style={[styles.shadow, {marginTop: 20}]}
        onPress={() => {
        openUrl("Catalog Update")}}
        >
         <Image
                style={styles.thumbnailImage}
                source={{
                uri: update.iconURL,
                }}
                />
                </Pressable>
                )}
                </>
): (<></>)}
        <Text style={styles.updateTitle}>{update.title}</Text>
         {update.image ? (
         <Pressable
         style={{backgroundColor: 'rgba(0,0,0,.8)', width: "100%"}}
         onLongPress={() => {openUrl("Catalog Update")}}
         >
          <Image
           style={styles.updateImage}
           source={{
           uri: update.image,
           }}
           />
           </Pressable>
           ):(
           <>
           </>
           )
         }
        <Text style={styles.updateDate}>{update.date}</Text>
        {update.attachments && (
        <>
        <Text style={{fontWeight: 'bold', fontSize: 18, marginTop: 10}}>Attachments</Text>
        <View style={styles.attachmentContainer}>
                <FlatList
                data={update.attachments}
                renderItem={renderAttachments}
                keyExtractor={(item) => item.title}
                removeClippedSubviews={true}
                showsVerticalScrollIndicator={false}
                horizontal={true}
                />
                </View>
                </>
        )}
        <View style={{margin: 20}}>
        {update.descriptionHTML? (
          <iframe srcdoc={update.descriptionHTML} width={descriptionWidth / 2} height={400} scroll={"auto"} frameBorder={0}/>
        ):(
        <Text>{update.description}</Text>
        )}
        </View>
        </ScrollView>
        </View>
        )}
        </SafeAreaView>
        </LinearGradient>
        </View>
        )
}